const [w] = [window]


export default function WORKS () {

  w.jQuery = $

  w.addScript({
    src: '/asset/js/vendor/jquery.event.move.js'
  })
  w.addScript({
    src: '/asset/js/vendor/jquery.twentytwenty.js'
  })

  $(w).on('load', () =>{
    $("#detailimage").twentytwenty();
  })
}